import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import AutoFixHighRoundedIcon from "@mui/icons-material/AutoFixHighRounded";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import QueryStatsRoundedIcon from "@mui/icons-material/QueryStatsRounded";
import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";

const items = [
	{
		icon: <SettingsSuggestRoundedIcon />,
		title: "Personalized Sobriety Tracking",
		description:
			"Users can journal their journey, log their drinks, and track progress toward sobriety in a private, user-friendly space.",
	},
	{
		icon: <ConstructionRoundedIcon />,
		title: "Supportive Community Features",
		description:
			"The app fosters connection with a vibrant community, allowing users to post, comment, like, and follow others on similar journeys.",
	},
	{
		icon: <ThumbUpAltRoundedIcon />,
		title: "Privacy-Focused Design",
		description:
			"Anonymity is the default, ensuring users can share and connect comfortably while keeping their personal information, journal entries, and email private.",
	},
	{
		icon: <AutoFixHighRoundedIcon />,
		title: "Motivational Tools",
		description:
			"Encouraging features like advice sections and emotional check-ins provide users with the tools to stay motivated and focused on their goals.",
	},
	{
		icon: <SupportAgentRoundedIcon />,
		title: "User-Friendly Interface",
		description:
			"Designed with ease of use in mind, the app enables seamless navigation and access to community features, journaling, and settings.",
	},
	{
		icon: <QueryStatsRoundedIcon />,
		title: "Holistic Approach to Sobriety",
		description:
			"Combines journaling, emotional tracking, AI Coaching, and community support to address both the emotional and practical aspects of quitting drinking, offering a well-rounded tool for personal growth.",
	},
];

export default function Highlights() {
	return (
		<Box
			id="highlights"
			sx={{
				pt: { xs: 4, sm: 12 },
				pb: { xs: 8, sm: 16 },
				color: "white",
				bgcolor: "grey.900",
			}}
		>
			<Container
				sx={{
					position: "relative",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					gap: { xs: 3, sm: 6 },
				}}
			>
				<Box
					sx={{
						width: { sm: "100%", md: "60%" },
						textAlign: { sm: "left", md: "center" },
					}}
				>
					<Typography component="h2" variant="h4" gutterBottom>
						Highlights
					</Typography>
					<Typography variant="body1" sx={{ color: "grey.400" }}>
						Explore why our product stands out: privacy, community,
						user-friendly design, and innovation. Enjoy reliable
						customer support and precision in every detail.
					</Typography>
				</Box>
				<Grid container spacing={2}>
					{items.map((item, index) => (
						<Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
							<Stack
								direction="column"
								component={Card}
								spacing={1}
								useFlexGap
								sx={{
									color: "inherit",
									p: 3,
									height: "100%",
									borderColor: "hsla(220, 25%, 25%, 0.3)",
									backgroundColor: "grey.800",
								}}
							>
								<Box sx={{ opacity: "50%" }}>{item.icon}</Box>
								<div>
									<Typography
										gutterBottom
										sx={{ fontWeight: "medium" }}
									>
										{item.title}
									</Typography>
									<Typography
										variant="body2"
										sx={{ color: "grey.400" }}
									>
										{item.description}
									</Typography>
								</div>
							</Stack>
						</Grid>
					))}
				</Grid>
			</Container>
		</Box>
	);
}
